class VideoManager {
  private videoPlayer: HTMLVideoElement | null = null;

  getCurrentVideoPlayer() {
    return this.videoPlayer;
  }

  setCurrentVideoPlayer(videoPlayer: HTMLVideoElement) {
    this.videoPlayer = videoPlayer;
  }
}

export default new VideoManager();
